
  // seleziona tutti gli elementi la cui classe inizia con "collapsible-trigger--"
  const triggers = document.querySelectorAll('[class^="collapsible-trigger--"]');
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      const content = this.nextElementSibling;
      const inner = content.querySelector('[class^="collapsible-inner--"]');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      if (!isExpanded) {
        content.style.height = inner.offsetHeight + 'px';
      } else {
        content.style.height = '0px';
      }
      
      this.setAttribute('aria-expanded', !isExpanded);
    });
  });

